import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import GridArea from 'templates/Layout/GridArea'
import MAIN_NAV_ITEMS from 'constants/MAIN_NAV_ITEMS'

const NavWrapper = styled(({...rest}) => <GridArea name={'nav'} {...rest} />)`
  align-items: center;
  display: flex;
  justify-self: center;
  min-width: 0;
  max-width: 100%;
  overflow-x: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`

const NavList = styled.ul`
  align-items: center;
  display: flex;
  gap: 18px;
  list-style: none;
  margin: 0;
  padding: 0;

  @media (max-width: ${p => p.theme.mediaTriggerWidth}) {
    gap: 12px;
  }
`

const NavLink = styled.a`
  align-items: center;
  color: ${p => p.theme.cLinkDarkBlue};
  display: inline-flex;
  font-family: inherit;
  font-size: 15px;
  font-weight: 400;
  justify-content: center;
  line-height: 18px;
  text-align: center;
  text-decoration: none;
  transition: color .2s ease, text-shadow .2s ease;
  white-space: nowrap;

  @media (max-width: ${p => p.theme.mediaTriggerWidth}) {
    font-size: 14px;
  }

  &:hover,
  &:focus {
    color: ${p => p.theme.cBlue};
    text-decoration: none;
    text-shadow: 0 0 8px rgba(3, 176, 246, .24);
  }

  &:focus-visible {
    outline: ${p => p.theme.cBlue} 2px solid;
    outline-offset: 3px;
  }

  &:active {
    color: ${p => p.theme.cBlueActive};
  }
`

const _PageHeader_Nav = () => {
  const { t } = useTranslation()

  return (
    <NavWrapper>
      <NavList>
        {MAIN_NAV_ITEMS.map(({title, href}) => (
          <li key={href}>
            <NavLink href={href}>
              {t(title)}
            </NavLink>
          </li>
        ))}
      </NavList>
    </NavWrapper>
  )
}

export default _PageHeader_Nav
